<hr />

<table id="add-member-table">
    <col width="15%">
    <col width="15%">
    <col width="15%">
    <col width="35%">
    <col width="20%">
    <tbody>
        <tr>
            <td></td>
            <td>Org Code</td>
            <td>Prop Code</td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td>{{groupKey}}</td>                
            <td>
                <input type="text" 
                        size="8"                        
                        tabindex="-1"                      
                        id="newOrgCode"
                        #newOrgCode
                        (input)="fieldChanged(newOrgCode)"
                        />
            </td>
            <td>
                <input type="text" 
                        size="8"                        
                        tabindex="-1" 
                        #newPropertyCode
                        id="newPropertyCode"
                        (input)="fieldChanged(newPropertyCode)"                                                
                        />
            </td>
            <td>    
                {{groupKey}}::{{newOrgCode.value}}::{{newPropertyCode.value}}
            </td>                
            <td style="text-align: center;">
                <div class="action-buttons" ngbTooltip="Save New Member">
                    <a (click)="addNewMember()">
                        <i class="fa fa-save" style="color: blue"></i>                        
                    </a>
                </div>
                <div class="action-buttons" ngbTooltip="Cancel">
                    <a (click)="cancelAddNewMember()">
                        <i class="fa fa-minus" style="color: red"></i>                        
                    </a>
                </div>
            </td>
        </tr>
    </tbody>
</table>
<p style="color:red; font-size: smaller;">{{errormessage}}</p>
